import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type State = {
    currency: string;
};

type Actions = {
    setCurrency: (currency: string) => void;
};

export const useGameCurrencyStore = create(
  persist<State & Actions>(
    (set) => ({
      currency: "",
      setCurrency: (currency: string) =>
        set(() => ({
          currency
        }))
    }),
    {
      name: "currency",
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);
